import { render, staticRenderFns } from "./DefaultAside.vue?vue&type=template&id=7ec7f373&"
import script from "./DefaultAside.vue?vue&type=script&lang=ts&"
export * from "./DefaultAside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports